module.exports = __webpack_public_path__ + "media/images/home/illustration_background-d3c4132fccba42ea4e35c074eff2e0c4.svg";